import { Dialog } from 'vant'

// 是否ios
function isIOS() {  
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;  
    return /iPad|iPhone|iPod/.test(userAgent) && 'ontouchend' in document;  
}
export const isIos = isIOS()

/**
 * 跳转APP
 * @param {Object} andriod 安卓对象
 * @param {String} andriod.default 学时版本
 * @param {String} andriod.custom 定制版本
 * @param {Object} ios ios对象
 * @param {String} ios.default 学时版本
 * @param {String} ios.custom 定制版本
 */

export const linkApp = function (
    appType = 1,
    android = {
        default: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen',
        custom: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
    },
    ios = {
        default: 'https://share.banbanjiadao.com/ui/h5/bbjd/index',
        custom: 'https://share.banbanjiadao.com/ui/h5/bb/index'
    }
) {
    // 判断设备
    if (isIos) {
        // 根据分享app类型跳转
        location.href = Number(appType) === 2 ? ios.default : ios.custom
    } else {
        // 根据分享app类型跳转
        location.href = Number(appType) === 2 ? android.default : android.custom
    }
}

// 分钟计算
export const formatSeconds = (s) => {
    s = parseInt(s)
    // 计算分钟
    // 算法：将秒数除以60，然后下舍入，既得到分钟数
    let h
    h = Math.floor(s / 60)
    // 计算秒
    // 算法：取得秒%60的余数，既得到秒数
    s = s % 60
    // 将变量转换为字符串
    h += ''
    s += ''
    // 如果只有一位数，前面增加一个0
    h = (h.length === 1) ? '0' + h : h
    s = (s.length === 1) ? '0' + s : s
    return h + ':' + s
}

/**
 * APP联调
 * @param {String} appOptions.name app方法名称
 * @param {Object} appOptions.data app方法接受的参数
 * @param {String} appOptions.currentFnName APP调用本地回调的方法名称
 * @param {Function} appOptions.callback 回调方法
 * @param {Function} appOptions.error 错误处理
 */
export const bindAppFn = function (appOptions) {
    let isIos = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    try {
        // 调用ios的方法
        if (isIos) {
            if (appOptions.currentFnName && appOptions.callback) {
                window[appOptions.currentFnName] = appOptions.callback
            }
            window.webkit.messageHandlers[appOptions.name].postMessage(appOptions.data)
        } else {
            // 调用andorid的方法
            const { method, params, type } = appOptions.data
            let result = null
            const arr = [JSON.stringify(params), type].filter((item) => (!!item))
            result = window[appOptions.name][method](...arr)
            appOptions.callback && appOptions.callback(result)
        }
    } catch (e) {
        appOptions.callback && appOptions.callback()
    }
}

// 教练端口版本
export const coachAppVersion = {
    iosVersion: '4.4.1', // 当前ios版本 最新版本
    androidVersion: '4.4.1', // 当前安卓最新版本
    versionName: '', // 获取到的最新版本
    isLastVersion: false, // 是否最新版
    getIsLastVersion () {
    },
}

// 获取app版本
export const getVersion = function () {
    return new Promise((resolve) => {
        bindAppFn({
            name: 'app',
            data: {
                method: 'getVersion',
                params: {}
            },
            currentFnName: 'getAppVersion',
            callback: (e = '{}') => { // 获取当前版本
                Dialog.alert({
                    message: e
                })
                const appVersion = JSON.parse(e)
                // 如果是ios 获取取得到
                const flag = isIos || !!appVersion.versionName
                console.log(flag)
                console.log(appVersion.versionName)
                resolve(flag)
            }
        })
    })
}